type tField = {
   id?: string;
   label?: string;
};

const normalizeFileName = (fileName: string) => {
   const normalized = fileName.trim().replace(/\s+/g, "_");
   if (!normalized) return "generateJSON.json";
   return `${normalized}.json`;
};

const buildJson = (inputData: tField[]) => {
   if (!Array.isArray(inputData)) return null;

   const map = inputData.reduce((acc, field) => {
      const { id, label } = field;

      if (!id || !label) return acc;
      if (acc[id] !== undefined) return acc;

      acc[id] = label;
      return acc;
   }, {});

   return JSON.stringify(map, null, 2);
};

export const downloadJson = (inputData: any, fileName: string = "generateJSON.json") => {
   const json = buildJson(inputData);
   if (!json) return;

   const blob = new Blob([json], { type: "application/json;charset=utf-8" });
   const url = URL.createObjectURL(blob);

   const a = document.createElement("a");
   a.href = url;
   a.download = normalizeFileName(fileName);
   a.click();

   URL.revokeObjectURL(url);
};
